import { HOURS_PER_DAY } from '../../constants';
import { toNumber } from '../numbers';

// Quota exprimé dans son unité native (jours ou heures) sur une durée de contrat en mois.
export function nativeQuota(
  qte: unknown,
  unite: string | null | undefined,
  contractMonths: number,
): number {
  const q = toNumber(qte) || 0;
  return unite && unite.endsWith('_an') ? q * (contractMonths / 12) : q * contractMonths;
}

// Conversion du quota natif en heures (pour comparaison à la consommation Jira, toujours en heures).
export function quotaInHours(
  qte: unknown,
  unite: string | null | undefined,
  contractMonths: number,
): number {
  const natif = nativeQuota(qte, unite, contractMonths);
  return unite && unite.startsWith('jours') ? natif * HOURS_PER_DAY : natif;
}
